module.exports = __webpack_public_path__ + "img/DNADamage-BRME_GSE179572.fc1c81ee.png";